/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";

const PlusIcon = ({ size = "small", className }: {size?: "small" | "large" | string, className?: string}) => {
  let iconSizeClassName;
  if (size === "small") {
    iconSizeClassName = "w-4 h-4";
  } else if (size === "large") {
    iconSizeClassName = "w-7 h-7";
  } else {
    iconSizeClassName = "w-9 h-9";
  }
  return (
    <svg
      className={cn(iconSizeClassName, "-mb-0", className)}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="currentColor"
      stroke="currentColor"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"
      />
    </svg>
  );
};
export default PlusIcon;
